import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import styles from './FullWidthRegion.css';

class FullWidthRegion extends Component {
  static propTypes = {
    seamless: PropTypes.bool,
    children: PropTypes.node,
  };

  static defaultProps = {
    seamless: false,
  };

  render() {
    const styleName = classnames('content', {
      seamless: this.props.seamless,
    });

    return (
      <div styleName="wrapper">
        <div styleName={styleName}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default CSSModules(FullWidthRegion, styles, {
  errorWhenNotFound: false,
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./application/js/components/FullWidthRegion.js